import { useSentry } from '../composables/sentry'
import { FirestoreCollection } from '../constants/firestoreCollection'
import FirestoreService from './FirestoreService'

const s = useSentry()

const SurchargeService = {
  getAll: async () => {
    let msg = ''
    try {
      const res = await FirestoreService.getDocsByMultipleQueries({
        collection: FirestoreCollection.Surcharges,
        ordering: [{ prop: 'calculation_order', value: 'asc' }, { prop: 'id', value: 'asc' }]
      })
      if (!res.success) {
        msg = 'Error getting surcharges'
        throw new Error(msg)
      }
      if (!res.data?.length) {
        msg = 'No surcharges found'
        throw new Error(msg)
      }
      return {
        success: true,
        data: res.data
      }
    }
    catch (error: any) {
      s.handleError(error)
      return {
        success: false,
        msg
      }
    }
  },
  getSingle: async (payload: any) => {
    let msg
    try {
      const res = await FirestoreService.getDocById(`${FirestoreCollection.Surcharges}/${payload.id}`)
      if (!res.success) {
        msg = 'Error getting surcharge'
        throw new Error(msg)
      }
      return {
        success: true,
        data: res.data
      }
    }
    catch (error: any) {
      s.handleError(error)
      return {
        success: false,
        msg
      }
    }
  },
  create: async (payload: any) => {
    let msg
    try {
      const newSurcharge = {
        ...payload
      }
      const res = await FirestoreService.setFirestoreDoc({
        docPath: `${FirestoreCollection.Surcharges}/${payload.id}`,
        data: newSurcharge
      })
      if (!res.success) {
        msg = 'Error creating surcharge'
        throw new Error(msg)
      }
      return {
        success: true,
        data: res.data
      }
    }
    catch (error: any) {
      s.handleError(error)
      return {
        success: false,
        msg
      }
    }
  },
  updateDoc: async (payload: any) => {
    const {
      id,
      data
    } = payload
    let msg
    try {
      const res = await FirestoreService.setFirestoreDoc({
        docPath: `${FirestoreCollection.Surcharges}/${id}`,
        data
      })
      if (!res.success) {
        msg = 'Error updating surcharge'
        throw new Error(msg)
      }
      return {
        success: true,
        data: res.data
      }
    }
    catch (error: any) {
      s.handleError(error)
      return {
        success: false,
        msg
      }
    }
  },
  deleteDoc: async (payload: any) => {
    let msg
    try {
      const res = await FirestoreService.deleteDoc(`${FirestoreCollection.Surcharges}/${payload.id}`)
      if (!res.success) {
        msg = 'Error deleting surcharge'
        throw new Error(msg)
      }
      return {
        success: true
      }
    }
    catch (error: any) {
      s.handleError(error)
      return {
        success: false,
        msg
      }
    }
  }
}

export default SurchargeService
